import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { deleteDocumentationDocumentAsync, getDocumentationDocumentByIdAsync } from '@application/features/documentation/documentationThunk';
import { useAppDispatch } from '@application/store/useStore';
import { formatDMY } from '@infrastructure/helpers';
import AttachmentPreviewModal from '@ui/components/VnAttachmentPreviewModal';
import VnButton from '@ui/components/VnButton';
import VnConfirmationModel from '@ui/components/VnConfirmationModel';
import ModalPopup from '@ui/components/VnModal';
import { downloadOutline, trashOutline } from 'ionicons/icons';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
const AttachmentTable = ({ documentationDocuments, onDocumentationDocumentGridUpdate }) => {
    const dispatch = useAppDispatch();
    const [isDeleteConformPopupOpen, setIsDeleteConformPopupOpen] = useState(false);
    const [selectedAttachmentId, setSelectedAttachmentId] = useState(0);
    const [isAttachmentPreviewOpen, setIsAttachmentPreviewOpen] = useState(false);
    const [attachmentSrc, setAttachmentSrc] = useState('');
    const { id } = useParams();
    const deleteDocumentationAttachment = (attachmentId) => {
        setIsDeleteConformPopupOpen(true);
        setSelectedAttachmentId(attachmentId);
    };
    function onCancelDeleteClicked() {
        setIsDeleteConformPopupOpen(false);
    }
    function onDeleteClicked() {
        if (selectedAttachmentId > 0) {
            dispatch(deleteDocumentationDocumentAsync(selectedAttachmentId))
                .unwrap()
                .then((res) => {
                onDocumentationDocumentGridUpdate();
                setIsDeleteConformPopupOpen(false);
                setSelectedAttachmentId(0);
            });
        }
    }
    function onRowClick(attachmentId) {
        const documentationDocument = {
            id: attachmentId,
            documentationId: parseInt(id)
        };
        dispatch(getDocumentationDocumentByIdAsync(documentationDocument))
            .unwrap()
            .then((res) => {
            const fileExtension = res.fileName.substring(res.fileName.lastIndexOf('.') + 1).toLocaleLowerCase();
            if (fileExtension === 'jpeg' || fileExtension === 'jpg') {
                setIsAttachmentPreviewOpen(true);
                setAttachmentSrc('data:image/jpeg;base64,' + res.document);
            }
            else if (fileExtension === 'png') {
                setIsAttachmentPreviewOpen(true);
                setAttachmentSrc('data:image/png;base64,' + res.document);
            }
            else if (fileExtension === 'pdf') {
                setIsAttachmentPreviewOpen(true);
                setAttachmentSrc('data:application/pdf;base64,' + res.document);
            }
            else if (fileExtension === 'xlsx' || fileExtension === 'xls' || fileExtension === 'csv') {
                const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.document}`;
                const downloadLink = document.createElement('a');
                const fileName = res.fileName;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }
            else {
                const linkSource = `data:application/octet-stream;base64,${res.document}`;
                const downloadLink = document.createElement('a');
                const fileName = res.fileName;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            }
        });
    }
    const oncloseClicked = () => {
        setIsAttachmentPreviewOpen(false);
    };
    const downloadDocumentationAttachment = (attachmentId) => {
        const documentationDocument = {
            id: attachmentId,
            documentationId: parseInt(id)
        };
        dispatch(getDocumentationDocumentByIdAsync(documentationDocument))
            .unwrap()
            .then((res) => {
            const fileExtension = res.fileName.substring(res.fileName.lastIndexOf('.') + 1);
            const downloadLink = document.createElement('a');
            let linkSource;
            if (fileExtension === 'jpeg' || fileExtension === 'jpg') {
                linkSource = `data:image/jpeg;base64,${res.document}`;
            }
            else if (fileExtension === 'png') {
                linkSource = `data:image/png;base64,${res.document}`;
            }
            else if (fileExtension === 'xlsx' || fileExtension === 'xls' || fileExtension === 'csv') {
                linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.document}`;
            }
            else {
                linkSource = `data:application/pdf;base64,${res.document}`;
            }
            downloadLink.href = linkSource;
            downloadLink.download = res.fileName;
            downloadLink.click();
        });
    };
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: 'custom-table-container', children: _jsx("div", { className: 'vn-table-container', children: _jsx("div", { className: 'vn-main', children: _jsxs("table", { className: 'table align-middle', children: [_jsx("thead", { className: 'vn-table-thead', children: _jsxs("tr", { className: 'vn-custom-grid-header-card', children: [_jsx("th", {}), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Bestandsnaam" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Titel" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Aangemaakt" }) }), _jsx("th", { children: _jsx("span", { className: 'header-caption', children: "Bestandstype" }) })] }) }), _jsx("tbody", { className: 'vn-table-tbody', children: documentationDocuments &&
                                        documentationDocuments?.map((attachment) => (_jsxs("tr", { style: { cursor: 'pointer' }, onClick: () => {
                                                onRowClick(attachment.id);
                                            }, children: [_jsx("td", { children: _jsxs("div", { className: 'd-flex gap-3', children: [_jsx(VnButton, { type: 'button', mode: 'danger', size: 'sm', customClassName: 'Vn-grid-delete-button', icon: trashOutline, onClick: (e) => {
                                                                    e.stopPropagation();
                                                                    deleteDocumentationAttachment(attachment.id);
                                                                } }), _jsx(VnButton, { type: 'button', mode: 'primary', size: 'sm', customClassName: 'Vn-grid-download-button', icon: downloadOutline, onClick: (e) => {
                                                                    e.stopPropagation();
                                                                    downloadDocumentationAttachment(attachment.id);
                                                                } })] }) }), _jsx("td", { children: _jsx("div", { className: 'mt-2', children: _jsx("span", { children: attachment.fileName.substring(0, attachment.fileName.lastIndexOf('.')) }) }) }), _jsx("td", { children: _jsx("div", { className: 'mt-2', children: _jsx("span", { children: attachment.title }) }) }), _jsx("td", { children: _jsx("div", { className: 'mt-2', children: _jsx("span", { children: formatDMY(attachment?.created.toString()) }) }) }), _jsx("td", { children: _jsx("div", { className: 'mt-2', children: attachment.fileName && (_jsxs("span", { children: [attachment.fileName.toLowerCase().split('.').pop()?.toUpperCase(), " File"] })) }) })] }, attachment.id))) })] }) }) }) }), _jsx(VnConfirmationModel, { title: 'Wilt u deze bijlage verwijderen?', onCancel: () => onCancelDeleteClicked(), onConfirm: () => onDeleteClicked(), onOpen: isDeleteConformPopupOpen }), _jsx(ModalPopup, { content: _jsx(AttachmentPreviewModal, { attachmentSrc: attachmentSrc, onClose: () => oncloseClicked() }), onOpen: isAttachmentPreviewOpen, onClose: () => oncloseClicked(), modalWidth: 'lg' })] }));
};
export default AttachmentTable;
